import React, { useEffect, useState } from "react";
import { Slide } from "@mui/material";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { CLEAR_REDUX_STATE } from "../../../store/clearstore";

export const useNavbarData = ({ onMobileClose, openMobile }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLogout, setIsLogout] = useState(false);

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location?.pathname]);

  const onLogout = async () => {
    localStorage.removeItem("adminLoginDetails");
    dispatch(CLEAR_REDUX_STATE.CLEAR_LOGIN_DETAILS());
    toast.success("Logout successful!");
    navigate("/admin-signin");
  };

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  return {
    location,
    navigate,
    isLogout,
    setIsLogout,
    onLogout,
    Transition,
  };
};
